/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoDeleteContactLinkInput = {
    clientMutationId?: string | null;
    entityType: string;
    entitySlug: string;
    role: string;
    contactSlug: string;
};
export type RemoveContactLinkDialogMutationVariables = {
    input: infoDeleteContactLinkInput;
};
export type RemoveContactLinkDialogMutationResponse = {
    readonly infoDeleteContactLink: {
        readonly deleted: boolean;
    } | null;
};
export type RemoveContactLinkDialogMutation = {
    readonly response: RemoveContactLinkDialogMutationResponse;
    readonly variables: RemoveContactLinkDialogMutationVariables;
};



/*
mutation RemoveContactLinkDialogMutation(
  $input: infoDeleteContactLinkInput!
) {
  infoDeleteContactLink(input: $input) {
    deleted
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoDeleteContactLinkPayload",
    "kind": "LinkedField",
    "name": "infoDeleteContactLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RemoveContactLinkDialogMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RemoveContactLinkDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4ff7ee68e7c2b0f185d026019b483a2e",
    "id": null,
    "metadata": {},
    "name": "RemoveContactLinkDialogMutation",
    "operationKind": "mutation",
    "text": "mutation RemoveContactLinkDialogMutation(\n  $input: infoDeleteContactLinkInput!\n) {\n  infoDeleteContactLink(input: $input) {\n    deleted\n  }\n}\n"
  }
};
})();
(node as any).hash = '91cfc64b653a5fa17df3dedbdd801119';
export default node;
